export default __webpack_public_path__ + "static/media/culture.6af74ea7.png";